export enum state {
  slogan = "En consigna",
  mechanic = "Mecánico",
  shelter = "Resguardo",
  in_manager_shelter = "En resguardo gestor",
  section = "Apartado",
  report = "Reporte",
  sold = "Vendido",
  sold_paid = "Vendido/Pagado",
  returned_to_the_client = "Devueltos al cliente",
  liquidation = "Liquidación",
  in_dation = "Dación",
}

export enum robbery_report_status {
  robbery_active = "Activo",
  resolved = "Resuelto",
  no_report = "Sin reporte",
  not_apply = "No aplica",
}
